import gsap from 'gsap'
import { Flip } from 'gsap/Flip'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { lenis } from './lenis'

gsap.registerPlugin(ScrollTrigger, Flip)

class CaseStudyBanner {
  constructor(el) {

    console.log('CaseStudyBanner')

    this.el = el
    this.pin = el.querySelector('.cs-intro__pin')
    this.media = el.querySelector('.cs-intro__media-holder')
    this.mediaInner = el.querySelectorAll('.cs-intro__media-holder img, .cs-intro__media-holder video')
    this.heading = el.querySelector('.cs-intro__heading')

    document.fonts.ready.then(() => {
      this.pinBanner()
      this.pageLoadAnimation()
    })
    
  }
  pinBanner() {
    this.pinTl = gsap.timeline({
      scrollTrigger: {
        trigger: this.pin,
        pin: true,
        start: 'top top',
        end: '+=1000'
      }
    })
  }
  pageLoadAnimation() {

    const words = this.heading.querySelectorAll('.word')
    const lines = this.heading.querySelectorAll('.line')
    const meta = this.el.querySelectorAll('.cs-intro__client span, .cs-intro__categories span, .cs-intro__project-url span')
    const hasPreloader = Alpine.store('hasPreloader').check

    console.log('pageLoadAnimation') 

    const tl = gsap.timeline({
      paused: true,
      onStart: () => {
        lenis.stop()
      },
      onComplete: () => { 
        lenis.start()
        this.expandMedia()
      }
    })

    if (hasPreloader) {
      Alpine.effect(() => {
        const preloader = Alpine.store('hasPreloader').check
        if (!preloader) tl.play()
      })
    } else {
      setTimeout(() => {
        tl.play()
      }, 100)
    }

    tl.to(words, {
      y: 0,
      duration: 2.85,
      stagger: 0.06,
      ease: 'expo.inOut',
      onStart: () => {
        console.log('Start words!')
      }
    })
    tl.from(meta, {
      yPercent: 150,
      duration: 2.85,
      stagger: 0.1,
      ease: 'expo.inOut'
    }, '<')
  
  }
  expandMedia() {

    // if (window.innerWidth <= 1024) return

    gsap.to(this.media, {
      scrollTrigger: {
        trigger: this.el,
        start: 'top top',
        end: '+=1000',
        scrub: 1.2,
      },
      scale: 1,
    })

    gsap.to(this.media, {
      y: 300,
      ease: 'none',
      scrollTrigger: {
        trigger: this.el,
        start: 'bottom bottom',
        end: 'bottom top',
        // invalidateOnRefresh: true,
        scrub: 0
      }
    })

    gsap.to(this.mediaInner, {
      scrollTrigger: {
        trigger: this.el,
        start: 'top top',
        end: '+=1000',
        // end: '+=1200',
        scrub: 1.2,
      },
      scale: 1
    })

    gsap.to(this.heading, {
      scrollTrigger: {
        trigger: this.el,
        start: 'top top',
        end: '+=200',
        scrub: 1.2,
      },
      color: 'transparent'
    })

  }
}

export const initCaseStudyBanner = () => {
  const banner = document.querySelector('.cs-intro')
  if (banner) new CaseStudyBanner(banner)
}

export default () => { }